class FindCartChipOffer extends HTMLElement {
  connectedCallback() {
    if (this.dataset.findInitialized === 'true') return;
    this.dataset.findInitialized = 'true';
    this.addEventListener('click', this.#onClick);
    this.#syncState();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #jsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  #onClick = async (event) => {
    const button = event.target.closest('[data-find-chip-action]');
    if (!button || !(button instanceof HTMLButtonElement)) return;

    event.preventDefault();
    if (window.__findChipActionInProgress) return;

    const action = button.dataset.findChipAction;
    const variantId =
      action === 'gift' ? Number(this.dataset.giftVariantId) : Number(this.dataset.cartVariantId);

    if (!variantId) return;

    window.__findChipActionInProgress = true;
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = action === 'gift' ? 'Gratis-Chip wird hinzugefügt …' : 'Wird hinzugefügt …';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: this.#jsonHeaders,
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
              properties: {
                _find_chip_offer: action === 'gift' ? '69-euro-giveaway' : 'cart-upsell',
              },
            },
          ],
        }),
      });

      if (!response.ok) throw new Error('Cart add failed');
      window.location.reload();
    } catch (error) {
      window.__findChipActionInProgress = false;
      button.disabled = false;
      button.textContent = originalText;
    }
  };

  async #syncState() {
    if (window.__findChipSyncInProgress) return;

    const eligible = this.dataset.eligible === 'true';
    const giftKey = this.dataset.giftKey || '';
    const giftQty = Number(this.dataset.giftQty || 0);
    const giftFree = this.dataset.giftFree === 'true';
    const paidKey = this.dataset.paidKey || '';
    const paidQty = Number(this.dataset.paidQty || 0);
    const giftVariantId = Number(this.dataset.giftVariantId || 0);

    try {
      if (giftKey && (!eligible || !giftFree || giftQty > 1)) {
        window.__findChipSyncInProgress = true;
        const desiredQty = eligible && giftFree ? 1 : 0;
        await this.#changeLine(giftKey, desiredQty);
        window.location.reload();
        return;
      }

      if (eligible && !giftKey && paidKey && giftVariantId) {
        window.__findChipSyncInProgress = true;
        await this.#changeLine(paidKey, Math.max(0, paidQty - 1));

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: this.#jsonHeaders,
          body: JSON.stringify({
            items: [
              {
                id: giftVariantId,
                quantity: 1,
                properties: {
                  _find_chip_offer: '69-euro-giveaway',
                },
              },
            ],
          }),
        });

        if (!addResponse.ok) throw new Error('Gift add failed');
        window.location.reload();
      }
    } catch (error) {
      window.__findChipSyncInProgress = false;
    }
  }

  async #changeLine(key, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: this.#jsonHeaders,
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!response.ok) throw new Error('Cart change failed');
    return response.json();
  }
}

if (!customElements.get('find-cart-chip-offer')) {
  customElements.define('find-cart-chip-offer', FindCartChipOffer);
}
